var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticStyle: { "font-size": "18px" }, attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            md10: "",
            lg10: "",
            "offset-md1": "",
            "offset-lg1": "",
          },
        },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: {
                dense: "",
                extended: "",
                color: "primary",
                dark: "",
                title: "Administration Area",
              },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("settings")]
                      ),
                      _vm._v("Administration Area\n        "),
                    ],
                    1
                  ),
                  _vm._v(
                    "In this area you can add/delete users and edit their personal information, modify access permission for\n        users across the system.\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "padding-10", attrs: { xs12: "" } },
                    [
                      _c("p", { staticClass: "dislodge_margin" }, [
                        _vm._v("\n            To\n            "),
                        _c("b", [_vm._v("manage users/tenants")]),
                        _vm._v(", choose one of the following:\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            activeLink:
                              _vm.$route.fullPath ==
                              "/administration/userManage",
                          },
                          attrs: { dark: "", color: "light-blue accent-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/administration/userManage"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("account_circle"),
                          ]),
                          _vm._v("Manage Users\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            activeLink:
                              _vm.$route.fullPath ==
                              "/administration/AdministrationAccessManage",
                          },
                          attrs: { dark: "", color: "light-blue accent-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/administration/accessManage"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("lock"),
                          ]),
                          _vm._v("Manage Tenants\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "padding-10", attrs: { xs12: "" } },
                    [
                      _c("p", { staticClass: "dislodge_margin" }, [
                        _vm._v("\n            To\n            "),
                        _c("b", [_vm._v("manage Media type")]),
                        _vm._v(", click the following:\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            activeLink:
                              _vm.$route.fullPath ==
                              "/administration/mediaType",
                          },
                          attrs: { dark: "", color: "light-blue accent-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/administration/mediaType"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("dns"),
                          ]),
                          _vm._v("Manage Media Type\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            activeLink:
                              _vm.$route.fullPath ==
                              "/administration/stationCategory",
                          },
                          attrs: { dark: "", color: "light-blue accent-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/administration/stationCategory"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("dns"),
                          ]),
                          _vm._v("Manage Station Category\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            activeLink:
                              _vm.$route.fullPath ==
                              "/administration/timeSeriesTag",
                          },
                          attrs: { dark: "", color: "light-blue accent-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/administration/timeSeriesTag"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", dark: "" } }, [
                            _vm._v("dns"),
                          ]),
                          _vm._v("Manage Time Series Tag\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Update from Aquarius"),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v("Update from Aquarius may takes a while, are you sure?"),
              ]),
              _vm._v(" "),
              _vm.synchronizing
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-card-text", {
                domProps: { innerHTML: _vm._s(_vm.syncrhonizeMessage) },
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", flat: "flat" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("No")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", flat: "flat" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.synchronizeAquariusDatabase.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v("Yes")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }